module.exports = __webpack_public_path__ + "img/no_image.4e6d8caa.png";